import { GAME_ID, REDUX_ACTIONS, DROPZONE_BORDER } from '../../data/constants';

const initialState = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  border: DROPZONE_BORDER.NONE,
};

// handles Dropzone related data and actions

const dropzoneReducer = (state = initialState, { gameId, type, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    // update state when gamestate data has been received
    case REDUX_ACTIONS.SET_DROPZONE:
      return {
        ...state,
        ...payload,
      };

    case REDUX_ACTIONS.SET_DROPZONE_BORDER:
      return {
        ...state,
        border: payload,
      };

    case REDUX_ACTIONS.DRAG_START:
      return {
        ...state,
        border: DROPZONE_BORDER.GRAY,
      };

    case REDUX_ACTIONS.DRAG_END:
      return {
        ...state,
        border: DROPZONE_BORDER.NONE,
      };

    case REDUX_ACTIONS.DRAG_ENTER_DROPZONE:
      return {
        ...state,
        border: DROPZONE_BORDER.AQUA,
      };

    case REDUX_ACTIONS.DRAG_EXIT_DROPZONE:
      return {
        ...state,
        border: DROPZONE_BORDER.GRAY,
      };

    default:
      return state;
  }
};

export default dropzoneReducer;
